import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import {getCollections} from '../../selectors/configSelectors';
import {TREEZ_ASSETS_URL} from '../../const/app_const';
import {getSelectedCustomerType} from '../../selectors/customer_type_selector';
import {getCollectionSearchQueryUrl} from '../../helpers/searchBarHelper';
import {push} from 'connected-react-router';

import './collectionBar.css';

function CollectionBar() {
    const dispatch = useDispatch();

    const collections = useSelector(getCollections);
    const customerType = useSelector(getSelectedCustomerType);
    const currentCollection = useSelector((state) => state.uri.queryParams.collections);

    return (
        <div className="collection-bar">
            {collections.map(c => (
                <a className={`collection ${c.id === parseInt(currentCollection, 10) ? 'collection-current' : ''}`}
                     onClick={(event) => {
                         event.stopPropagation();
                         dispatch(push(getCollectionSearchQueryUrl(c.id)));
                     }}>
                    <img src={`${TREEZ_ASSETS_URL}/${c.icon}`} alt={c.name} />
                    <label>{c.name}</label>
                </a>
            ))}
        </div>
    )
}

export default CollectionBar;



// WEBPACK FOOTER //
// ./src/components/CollectionBar/CollectionBar.jsx